import { factory } from './app';

factory('LlmService', [
  '$http',
  function($http) {
    return {
      validateAuthForm
    };

    function validateAuthForm(entityName, file) {
      var formData = new FormData();
      formData.append('entityName', entityName);
      formData.append('file', file);

      var options = {
        method: 'POST',
        url: '/lei/extractors/validateAuthForm',
        data: formData,
        headers: {
          'Content-Type': undefined
        }
      };

      return $http(options);
    }
  }
]);
